import { get } from 'lodash';

export const checkNeededStep = row => {
  return get(row, 'workflow_data.print.next_step.process') === 'Build Print Job';
};
